import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IAssetCategory } from "./models/assets";

@Injectable({
  providedIn: "root",
})
export class AssetCategoriesService {
  private baseUrlCategories: string = "/asset-category";
  public categoriesList: IAssetCategory[] = [];

  constructor(public _httpClient: HttpClient) {}

  async getCategoriesList() {
    return this._httpClient
      .get(this.baseUrlCategories)
      .toPromise()
      .then((response: IAssetCategory[]) => {
        this.categoriesList = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async deleteCategory(id: number) {
    return this._httpClient
      .delete(this.baseUrlCategories + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getCategoriesList();
        return response;
      });
  }

  async createCategory(data: { name: string; description: string; parent_id: number }) {
    return this._httpClient
      .post(this.baseUrlCategories, data)
      .toPromise()
      .then(async (response) => {
        await this.getCategoriesList();
        return response;
      });
  }

  async updateCategory(id: number, data: { name: string; description: string; parent_id: number }) {
    return this._httpClient
      .put(this.baseUrlCategories + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getCategoriesList();
      });
  }
}
